import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import QuilHelper from '../../puck/reusable-props/quilHelper';
import { useState } from 'react';

interface QuillFieldRendererProps {
  label: string;
  value: string;
  onChange: (_val: string) => void;
  id?: number;
  isOpen?: boolean;
  onToggle?: () => void;
}

const QuillFieldRenderer = ({
  label,
  value,
  onChange,
  id,
  isOpen,
  onToggle,
}: QuillFieldRendererProps) => {
  const [isOpen1, setIsOpen1] = useState(false);
  return (
    <>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 pagebuilder-theme border-b border-gray-200"
        onClick={onToggle ? onToggle : () => setIsOpen1(!isOpen1)}>
        <h3>{label}</h3>
        {!(isOpen || isOpen1) ? (
          <KeyboardArrowDownIcon />
        ) : (
          <KeyboardArrowUpIcon />
        )}
      </div>
      {(isOpen || isOpen1) && (
        <QuilHelper value={value} onChange={onChange} id={id} />
      )}
    </>
  );
};

export default QuillFieldRenderer;
